import http_request from './http_request'
import config from 'config'

function saveTimer(timer, id) {
	return http_request.put(config.api + 'slide/' + id + '/timer')
		.send({
			timer,
		})
}

export default {
	saveTimer,
}

/**
 * TODO: Change other activities that uses timer to start using this sync instead - Techdebt NP-9720
 */
